window._learnq = window._learnq || [];

const AGGREGATION_DELAY = 12000; // 12 seconds — adjust if you'd like a longer/shorter window
const DEADLINE_KEY = 'klaviyo_cart_aggregation_deadline';
let aggregationTimer = null;

function getDeadline() {
  const v = localStorage.getItem(DEADLINE_KEY);
  return v ? parseInt(v, 10) : null;
}
function setDeadline(ts) {
  localStorage.setItem(DEADLINE_KEY, String(ts));
}
function clearDeadline() {
  localStorage.removeItem(DEADLINE_KEY);
}

function sendCartEvent() {
  if (getDeadline() === null) return;
  clearDeadline();
  fetch('/cart.js')
    .then((response) => response.json())
    .then((cart) => {
      if (!cart.items.length) return;
      const items = cart.items.map((item) => ({
        ProductID: item.product_id,
        SKU: item.sku,
        ProductName: item.title,
        Quantity: item.quantity,
        ItemPrice: item.price / 100,
        RowTotal: (item.price * item.quantity) / 100,
        ProductURL: `${window.location.origin}/products/${item.handle}`,
        ImageURL: item.image ? (item.image.startsWith('//') ? `https:${item.image}` : item.image) : ''
      }));
      window._learnq.push([
        'track',
        'Cart Updated',
        {
          $value: cart.total_price / 100,
          ItemCount: items.length,
          ItemNames: items.map((item) => item.ProductName),
          CheckoutURL: `${window.location.origin}/checkout`,
          Items: items
        }
      ]);
      console.log('Cart tracking event sent:', items);
    })
    .catch((error) => console.error('Cart tracking failed:', error));
}

function armTimer(delayMs) {
  clearTimeout(aggregationTimer);
  aggregationTimer = setTimeout(sendCartEvent, delayMs);
}
function scheduleCartEvent() {
  setDeadline(Date.now() + AGGREGATION_DELAY);
  armTimer(AGGREGATION_DELAY);
}
(function resume() {
  const deadline = getDeadline();
  if (deadline === null) return;
  const remaining = deadline - Date.now();
  if (remaining <= 0) sendCartEvent();
  else armTimer(remaining);
})();
window.addEventListener('storage', function (e) {
  if (e.key !== DEADLINE_KEY) return;
  if (e.newValue === null) clearTimeout(aggregationTimer);
  else armTimer(Math.max(parseInt(e.newValue, 10) - Date.now(), 0));
});

const originalFetch = window.fetch;
window.fetch = function (...args) {
  const requestUrl = typeof args[0] === 'string' ? args[0] : args[0] && args[0].url;
  const response = originalFetch.apply(this, args);
  if (requestUrl && new URL(requestUrl, window.location.origin).pathname === '/cart/add.js') {
    response.then(() => scheduleCartEvent());
    console.log('Cart tracking event scheduled');
  }
  return response;
};
